import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";
import { StoreContext } from "../context/StoreContext";

const DestinationPicker = () => {
  const { setDestination, setSource, source , setRequestId} = useContext(StoreContext);
  const location = useLocation();
  const navigate = useNavigate();
  
   // ✅ Store source details properly
   useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sourceString = queryParams.get("source");  // Example: "28.7041,77.1025"
    const sourceRequestId = queryParams.get("sessionId");
    console.log("RequestId : ",sourceRequestId);
    

    if (sourceString) {
      const [lat, lng] = sourceString.split(",").map(coord => parseFloat(coord.trim())); 
      const sourceCoords = `${lat},${lng}` 
      setSource(sourceCoords); 
      setRequestId(sourceRequestId);
      console.log("Req id",sourceRequestId);
      console.log(" source:", sourceCoords);
    }

    console.log("Source in Destination Page:", source);
  }, [location.search]);

  

  const handlePlaceSelect = (place) => {
    if (place.geometry) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const destinationCoords = `${lat},${lng}`;
      setDestination(destinationCoords);
      
      console.log(" Destination:", destinationCoords);
      navigate(`/suggestions`);
    }
  };

  return (
    <div className="pt-24 w-full h-full flex flex-col bg-white">
      <div className="flex flex-col items-center">
        <h1 className="text-xl font-semibold mb-4">Select Your Destination</h1>
        <Autocomplete
          apiKey="AIzaSyDsLudku5DdZHWZYE9Oojk6kq2ImSr3CnQ"
          onPlaceSelected={handlePlaceSelect}
          options={{ types: ["(cities)"] }}
          className="border p-2 rounded w-80"
          placeholder="Search your destination..."
        />
      </div>
    </div>
  );
};

export default DestinationPicker;
